import { AnimatedRegion } from '@affine/core/components/animation/animated-region';
import type { ComponentProps, ReactNode } from 'react';

import { AnimatedNavigationPanelTreeChildren } from './animated-children';

type AnimatedNavigationPanelTreeDisclosureContentProps = Omit<
  ComponentProps<typeof AnimatedRegion>,
  'children' | 'expanded'
> & {
  collapsed: boolean;
  children?: ReactNode;
  placeholder?: ReactNode;
};

export const AnimatedNavigationPanelTreeDisclosureContent = ({
  collapsed,
  children,
  placeholder,
  ...contentProps
}: AnimatedNavigationPanelTreeDisclosureContentProps) => {
  return (
    <AnimatedRegion
      {...contentProps}
      expanded={!collapsed}
      animateContent={false}
      aria-hidden={collapsed}
      inert={collapsed ? true : undefined}
    >
      <AnimatedNavigationPanelTreeChildren>
        {placeholder}
      </AnimatedNavigationPanelTreeChildren>
      <AnimatedNavigationPanelTreeChildren>
        {children}
      </AnimatedNavigationPanelTreeChildren>
    </AnimatedRegion>
  );
};
